'use client';

import React from 'react';
import type { DialogProps } from '../Dialog';
import { Button } from '../../Button/Button';
import { cn } from '../../../utils/cn/cn';

export type DialogHeaderProps = React.HTMLAttributes<HTMLDivElement> &
  Pick<DialogProps, 'onClose'> & {
    /** Callback fired when the header requests to return to the previous page */
    onBack?: () => void;
  };

/**
 * The dialog header container
 */
const DialogHeader = ({ children, className, onBack, onClose, ...props }: DialogHeaderProps) => (
  <header
    {...props}
    className={cn(
      'border-color-grey flex w-full items-center justify-between border-b px-3 sm:min-h-[64px]',
      className,
    )}
  >
    {onBack && (
      <Button
        variant="icon-flat"
        onClick={(e) => {
          // prevent submitting forms
          e.preventDefault();
          onBack();
        }}
        className="bg-color-transparent h-4 w-4 rounded-sm border-0 p-0"
      >
        <span className="icon-emp-arrow-medium-left h-4 w-4" />
      </Button>
    )}
    <span className="lg:text-size-h4 text-size-h5">{children}</span>
    <Button
      variant="icon-flat"
      onClick={(e) => {
        // prevent submitting forms
        e.preventDefault();
        onClose();
      }}
      className="bg-color-transparent h-4 w-4 rounded-sm border-0 p-0"
    >
      <span className="icon-emp-cancel h-4 w-4" />
    </Button>
  </header>
);

DialogHeader.displayName = 'DialogHeader';

export { DialogHeader };
